import { Button, Result } from 'antd'

import { PageContainer } from '@eastcoal/common/components/Layout/PageContainer'

import { useNavigate } from '@eastcoal/router/exports/react-router'

export const AuditSuccessfulPage = () => {
  const navigate = useNavigate()

  return (
    <PageContainer>
      <Result
        status='success'
        title='操作成功'
        extra={[
          <Button
            key='navigatorAuditDetailBtn'
            type='primary'
            onClick={() => navigate(-1)}
          >
            查看认证详情
          </Button>,
          <Button
            key='navigatorHistoryBtn'
            type='default'
            onClick={() => navigate(-2)}
          >
            返回列表页
          </Button>
        ]}
      />
    </PageContainer>
  )
}
